/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'

import { Trans } from '@mc/i18n'
import { paths } from '@mc/paths'

import { GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE, i18nInstance } from '../i18n'

export type Question = {
  title: string
  uuid: string
  answer: string | React.ReactNode
  hide?: boolean
}

export type Section = {
  title: string
  questions: Question[]
}

const t = i18nInstance.getFixedT(null, GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE)

export const getGiftPageFaqSection: () => Section = () => ({
  title: '',
  questions: [
    {
      title: t('faq.question1'),
      uuid: 'faq.question1',
      answer: (
        <Trans i18nKey='faq.answer1' ns={GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE}>
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    {
      title: t('faq.question2'),
      uuid: 'faq.question2',
      answer: (
        <Trans i18nKey='faq.answer2' ns={GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE}>
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    {
      title: t('faq.question3'),
      uuid: 'faq.question3',
      answer: (
        <Trans i18nKey='faq.answer3' ns={GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE}>
          <p className='mc-opacity--hinted'>
            <a className='mc-text--link' href={paths.giftSupport} />
          </p>
        </Trans>
      ),
    },
    {
      title: t('faq.question4'),
      uuid: 'faq.question4',
      answer: (
        <Trans i18nKey='faq.answer4' ns={GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE}>
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    {
      title: t('faq.question5'),
      uuid: 'faq.question5',
      answer: (
        <Trans i18nKey='faq.answer5' ns={GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE}>
          <p className='mc-opacity--hinted' />
          <p className='mc-opacity--hinted'>
            <a className='mc-text--link' href={paths.giftTerms} />
          </p>
        </Trans>
      ),
    },
    {
      title: t('faq.question6'),
      uuid: 'faq.question6',
      answer: (
        <Trans i18nKey='faq.answer6' ns={GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE}>
          <p className='mc-opacity--hinted'>
            <a className='mc-text--link' href={paths.helpCenterMasterClass} />
          </p>
        </Trans>
      ),
    },
  ],
})
